import React from "react";

import SmallLine from "./../GraphViews/SmallLine";
import Arrow from "./../GraphViews/Arrow";
import PercentageSmallLine from "./../GraphViews/PercentageSmallLine";
import NameSmallLine from "./../GraphViews/NameSmallLine";
import { updateRankElements } from "./../../utils";
import StatsUtils from "../../../../utils/stats";
import moment from "moment";
import Spinner from "../Spinner";

const MutliLinesView = props => {
  const dataElementLine = props.data || {};
  const nbElements = Object.keys(dataElementLine).length;
  let elementsExtremeScores = {
    first: -Infinity,
    last: Infinity,
    second: -Infinity,
    third: -Infinity,
    secondLast: Infinity,
    thirdLast: Infinity
  };
  let min = -1;
  let max = -1;
  const dataElements = Object.keys(dataElementLine).map(elementName => {
    const dataElementName = dataElementLine[elementName].data || [];
    const indicator = dataElementLine[elementName].indicator || 0;
    const percentagesArray = dataElementName.map(data => {
      const v = data.v || 0;
      //set min / max values
      if (min === -1) {
        min = v;
      } else {
        min = Math.min(min, v);
      }
      if (max === -1) {
        max = v;
      } else {
        max = Math.max(max, v);
      }
      return v;
    });
    const percentagesArrayRounded = dataElementName.map(data => {
      return StatsUtils.roundKpiValue(props.kpi, data.v, 1);
      if ((props.kpi && props.kpi.format === "Pourcentage") || props.kpi.format_input === "percentage")
        return Number(StatsUtils.formatKpiValue(props.kpi, data.v).slice(0, -1));

      return Number(
        StatsUtils.formatKpiValue(props.kpi, data.v)
          .replace(/\s/g, "")
          .replace(/\€/g, "")
      );
    });
    const newestPercentage = percentagesArray.length > 0 ? percentagesArray[percentagesArray.length - 1] : 0;
    const oldestPercentage = percentagesArray.length > 0 ? percentagesArray[0] : 0;

    const trend = Math.sign(newestPercentage - oldestPercentage);
    updateRankElements(newestPercentage, elementsExtremeScores, nbElements);

    const color = trend === 1 ? "#54CD98" : trend === -1 ? "#DB1E08" : "#FEA701";
    const data = {
      datasets: [
        {
          data: percentagesArrayRounded,
          fill: true,
          lineTension: 0.1,
          backgroundColor: color,
          borderColor: color,
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "round",
          pointBorderColor: color, //"rgba(75,192,192,1)",
          pointBackgroundColor: color,
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: color, //"rgba(75,192,192,1)",
          pointHoverBorderColor: "rgba(220,220,220,1)",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10
        }
      ],
      // labels: Array(percentagesArray.length).fill(""),
      labels: dataElementName.map(data => {
        return `${moment(data.date).format()}`;
      })
    };
    return {
      indicator,
      data,
      elementName,
      percentagesArray,
      percentagesArrayRounded,
      trend
    };
  });

  dataElements.map(data => {
    const newestPercentage =
      data.percentagesArray && data.percentagesArray.length > 0
        ? data.percentagesArray[data.percentagesArray.length - 1]
        : 0;
    if (newestPercentage === elementsExtremeScores.first) data.displayTop = "icon-star-1";
    if (newestPercentage === elementsExtremeScores.second) data.displayTop = "icon-star-2";
    if (newestPercentage === elementsExtremeScores.third) data.displayTop = "icon-star-3";

    if (newestPercentage === elementsExtremeScores.last) data.displayBottom = "icon-flop-3";
    if (newestPercentage === elementsExtremeScores.secondLast) data.displayBottom = "icon-flop-2";
    if (newestPercentage === elementsExtremeScores.thirdLast) data.displayBottom = "icon-flop-1";
    return data;
  });

  return (
    <React.Fragment>
      <h2 className="p-page-subtitle p-txt-center">{props.title}</h2>
      <div
        className="p-al-v-center p-al-wrap"
        style={{
          justifyContent: "space-between",
          height: "calc(100% - 25px)",
          position: "relative" // ??
        }}
      >
        {props.loading ? <Spinner style={{ top: 100 }} /> : null}

        {/* {props.title} */}

        {!props.loading &&
          dataElements
            .sort((a, b) => {
              return b.indicator - a.indicator;
            })
            .map((element, i) => (
              <div
                key={i}
                className="p-w-100 p-mrg-hor-s p-al-full"
                style={{
                  alignItems: "center",
                  //height: `${100 / dataElements.length}%`,
                  width: "100%",
                  height: "85px"
                }}
              >
                <NameSmallLine
                  name={element.elementName}
                  displayTop={element.displayTop}
                  displayBottom={element.displayBottom}
                  width="30%"
                />
                <Arrow size="small" trend={element.trend} width="15%" />
                <PercentageSmallLine
                  percentage={element.indicator}
                  percentage2={
                    element.percentagesArrayRounded.length > 0
                      ? element.percentagesArrayRounded[element.percentagesArrayRounded.length - 1]
                      : 0
                  }
                  width="15%"
                  kpi={props.kpi}
                />
                <SmallLine min={min} max={max} width="35%" height="100%" data={element.data} period={props.period} />
              </div>
            ))}
      </div>
    </React.Fragment>
  );
};

export default MutliLinesView;



// WEBPACK FOOTER //
// src/modules/stats/components/DashboardViews/MultiLinesView.js